export class WebApiInfo {
  public static CreateInvalidWebApiBaseURLInfo(baseURL: string) {
    const info = new WebApiInfo(baseURL, null, true, false, false, null, null, null);
    info._isBaseURLInvalid = true;

    return info;
  }

  constructor(
    public readonly baseURL: string,
    public readonly displayText: string,
    public readonly needsAuthentication: boolean,
    public readonly useLocalSecurityContext: boolean,
    public readonly useRemoteSecurityContext: boolean,
    public readonly fixedCulture: string,
    public readonly version: string,
    public readonly systemInfo: WebApiSystemInfo,
  ) {
    this._isBaseURLInvalid = false;
  }

  private _isBaseURLInvalid: boolean;
  public get isBaseURLInvalid(): boolean {
    return this._isBaseURLInvalid;
  }
}

export class WebApiSystemInfo {
  public Name: string;
}
